{
  "loading": "Laster inn ...",
  "placeholder": "Velg …"
}
